<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="complete-buy-point">
      <Title :jpn="t('購入完了')" />
      <div class="area_box">
        <div class="flex-box">
          <div v-if="isImmediate" class="text thanks immediate">
            <span>{{ t('Xmarketのご利用ありがとうございました') }}</span>
            <span>{{ t('引き続きGTCHAX Onlineをお楽しみください。') }}</span>
          </div>
          <div v-if="!isImmediate" class="text thanks delay">
            <span>{{ t('決済に失敗しました。') }}</span>
            <span>{{ t('他の決済方法をご利用ください。') }}</span>
          </div>
        </div>
      </div>
      <BuyButton
        class="purchase-btn square-button"
        :isArrow="false"
        :text="t('HOMEへ戻る')"
        @handleSquareBtnClick="goToTop"
    />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title02.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'CompleteBuyPointPayPal',
  mixins: [t],

  // beforeRouteLeave(to, from, next) {
  //   if (to.name === 'PayRedirect') {
  //     next(false);
  //   } else {
  //     next();
  //   }
  // },

  components: {
    BaseTemplate,
    Title,
    BuyButton,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentPack: 'pack/currentPack',
      resultMarketBuyComplete: 'market/resultMarketBuyComplete',
      resultMarketCheckCart: 'market/resultMarketCheckCart',
    }),
    isMoreThanPackPoint() {
      if (this.currentPack && this.currentUser) {
        return parseInt(this.currentUser.point, 10) > parseInt(this.currentPack.point, 10);
      }
      return false;
    },
    isImmediate() {
      if (this.resultMarketBuyComplete) {
        const isSuccess = this.resultMarketBuyComplete.success === true || this.resultMarketBuyComplete.success === 'true';
        return isSuccess;
      }
      return false;
    },
    isFromConfirm() {
      return this.$route.query.fromConfirm === 'true' || this.$route.query.fromConfirm === true;
    },
  },

  watch: {
    resultMarketBuyComplete(newVal) {
      if (newVal) {
        this.$store.dispatch('user/setCurrentUser');
      }
    },
  },

  created() {
    this.$store.dispatch('market/buy_complete');
  },

  methods: {
    goToTop() {
      this.$router.push('/');
    },
    goToBuyProduct() {
      const query = {
        packId: this.pointAppendResult.pack_id,
      };
      this.$router.push({ path: '/buy-product', query });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-box {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.area_box {
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
}
.complete-buy-point{
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding-top: 0px;
  margin: 0px auto;
  text-align: center;
  // @include appendMap($backgroundStyleMap);
  .icon {
    margin: 50px 0;
    img {
      width: 244px;
    }
  }
  .text.thanks{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: $notoSans;
    font-size: 18px;
    line-height: 32.4px;
    // color: $white;
    margin: 30px auto;
  }
  .delay{
    margin-top: 40px;
  }
  .purchase-btn{
    width: 200px;
    height: 50px;
    margin: auto;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .leaf_box {
    margin: 0 10px;
  }
}
</style>
